var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isIntroductionModalVisible,
          expression: "isIntroductionModalVisible"
        }
      ]
    },
    [
      _c("div", { staticClass: "modal-mask", on: { click: _vm.closeModal } }, [
        _vm.loading == false
          ? _c(
              "div",
              {
                staticClass: "modal-container",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-1 p-0 float-left bold",
                      staticStyle: { "text-align": "right" }
                    },
                    [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            staticStyle: { margin: "-15px 0 -15px 0" },
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.closeModal }
                          },
                          [_vm._v("×")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.showSlideNumbers === true
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-top": "22px",
                                margin: "0 4px 0 0"
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(parseInt(this.index + 1)) +
                                  "/" +
                                  _vm._s(this.introductionSlideObj.length) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    class:
                      _vm.selectedSlide.showSkipButton === true
                        ? "modal-body-h1"
                        : "modal-body-h2"
                  },
                  [
                    _c("div", { staticClass: "col-12 p-0 slide-title" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.selectedSlide.title) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "10px" } }),
                    _vm._v(" "),
                    _vm.selectedSlide.template == 1
                      ? _c(
                          "div",
                          _vm._l(_vm.selectedSlide.item, function(
                            item,
                            iindex
                          ) {
                            return _c(
                              "div",
                              { key: iindex, staticClass: "col-12 p-0" },
                              [
                                item.type == "Text"
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 item-text" },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(item.text)
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type == "Image"
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 text-center" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: item.image_link,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: item.image,
                                                width: "180px",
                                                height: "100px"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type == "Button"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "col-12 text-align-right"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-md start-button-blue",
                                            staticStyle: {
                                              width: "auto !important"
                                            },
                                            attrs: { type: "submit" },
                                            on: {
                                              click: function($event) {
                                                return _vm.buttonClick(
                                                  item.image_link
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.text))]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type == "Link"
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 text-center" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: item.image_link,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(item.text)
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type == "Assessment"
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 p-0 text-center" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 p-0 bold assessment_title"
                                          },
                                          [_vm._v(_vm._s(item.assessmentTitle))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 p-0 question_text"
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(item.totalQuestions) +
                                                " Questions\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 p-0 text-center"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-md start-button-blue",
                                                attrs: { type: "submit" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goToAssessmentLanding(
                                                      item.assessmentId,
                                                      item.inprogressAttemptId,
                                                      item.totalQuestions,
                                                      item.userAssessmentMappingId
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Begin")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type == "Course"
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 p-0 text-center" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 p-0 bold assessment_title"
                                          },
                                          [_vm._v(_vm._s(item.text))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 p-0 question_text"
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(item.moduleCount) +
                                                " Modules\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 p-0 text-center"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-md start-button-blue",
                                                attrs: { type: "submit" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goToCourseLanding(
                                                      item.courseId,
                                                      item.userCourseMappingId
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Begin")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: {
                                            "margin-bottom": "10px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedSlide.template == 2
                      ? _c("div", [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "col-6 float-left" },
                              _vm._l(_vm.selectedSlide.item, function(
                                item,
                                iindex
                              ) {
                                return _c("div", { key: iindex }, [
                                  iindex == 0 || iindex == 3
                                    ? _c("div", [
                                        item.type == "Text"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "col-12 item-text"
                                              },
                                              [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(item.text)
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Image"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: item.image_link,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: item.image,
                                                        width: "180px",
                                                        height: "100px"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Link"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "link_text",
                                                    attrs: {
                                                      href: item.image_link,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          item.text
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Button"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "col-12 text-left"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-md start-button-blue",
                                                    staticStyle: {
                                                      width: "auto !important"
                                                    },
                                                    attrs: { type: "submit" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.buttonClick(
                                                          item.image_link
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Assessment"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 bold assessment_title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.assessmentTitle
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 question_text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          item.totalQuestions
                                                        ) +
                                                        " Questions\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 text-center"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-md start-button-blue",
                                                        attrs: {
                                                          type: "submit"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.goToAssessmentLanding(
                                                              item.assessmentId,
                                                              item.inprogressAttemptId,
                                                              item.totalQuestions,
                                                              item.userAssessmentMappingId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Begin")]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Course"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 bold assessment_title"
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 question_text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          item.moduleCount
                                                        ) +
                                                        " Modules\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 text-center"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-md start-button-blue",
                                                        attrs: {
                                                          type: "submit"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.goToCourseLanding(
                                                              item.courseId,
                                                              item.userCourseMappingId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Begin")]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-6 float-left" },
                              _vm._l(_vm.selectedSlide.item, function(
                                item,
                                iindex
                              ) {
                                return _c("div", { key: iindex }, [
                                  iindex == 1 || iindex == 2 || iindex == 4
                                    ? _c("div", [
                                        item.type == "Text"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "col-12 item-text"
                                              },
                                              [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(item.text)
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Image"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: item.image_link,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: item.image,
                                                        width: "180px",
                                                        height: "100px"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Link"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "link_text",
                                                    attrs: {
                                                      href: item.image_link,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          item.text
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Button"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-align-right"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-md start-button-blue",
                                                    staticStyle: {
                                                      width: "auto !important"
                                                    },
                                                    attrs: { type: "submit" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.buttonClick(
                                                          item.image_link
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Assessment"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 bold assessment_title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.assessmentTitle
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 question_text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          item.totalQuestions
                                                        ) +
                                                        " Questions\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 text-center"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-md start-button-blue",
                                                        attrs: {
                                                          type: "submit"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.goToAssessmentLanding(
                                                              item.assessmentId,
                                                              item.inprogressAttemptId,
                                                              item.totalQuestions,
                                                              item.userAssessmentMappingId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Begin")]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type == "Course"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-center"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 bold assessment_title"
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 question_text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          item.moduleCount
                                                        ) +
                                                        " Modules\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 p-0 text-center"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-md start-button-blue",
                                                        attrs: {
                                                          type: "submit"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.goToCourseLanding(
                                                              item.courseId,
                                                              item.userCourseMappingId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Begin")]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticStyle: {
                                                    "margin-bottom": "10px"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticStyle: { clear: "both" } })
                  ]
                ),
                _vm._v(" "),
                _vm.selectedSlide.showSkipButton === true
                  ? _c("div", { staticClass: "modal-footer" }, [
                      this.introductionSlideObj.length !=
                      parseInt(this.index + 1)
                        ? _c("div", { staticClass: "col-12 p-0" }, [
                            _c(
                              "div",
                              { staticClass: "col-6 float-left p-0 text-left" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-md start-button",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeModal()
                                      }
                                    }
                                  },
                                  [_vm._v("Skip")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-6 float-left p-0 text-align-right"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-md start-button-blue",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        return _vm.getNextPrev()
                                      }
                                    }
                                  },
                                  [_vm._v("Next")]
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "col-12 p-0" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 p-0 text-center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-md start-button-blue",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeModal()
                                      }
                                    }
                                  },
                                  [_vm._v("Close")]
                                )
                              ]
                            )
                          ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-11 p-0 float-left text-center" }, [
      _c("img", {
        staticClass: "w-60 mt1",
        attrs: {
          src: require("@/assets/MM-logo.png"),
          alt: "MentorMentee",
          width: "100px"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8049fdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8049fdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/introductionManagerTemplateModal.vue
// module id = null
// module chunks = 